import { Result } from 'antd';
import { useContext } from 'react';
import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { ContextApp } from '../contexts/ContextApp';
import { useCurrentRoute } from './useCurrentRoute';

export const useCheckAuthority = (): JSX.Element | null => {
  const { functions, t } = useContext(ContextApp);
  const { leafRoute } = useCurrentRoute();

  if (
    leafRoute?.authority &&
    !functions?.find((item) => item === leafRoute.authority)
  ) {
    return (
      <Result
        status="403"
        title="403"
        subTitle={t('error.unauthorizedPage')}
        extra={<Link to="/">{t('abm.goBackHome')}</Link>}
      />
    );
  }
  return null;
};
